<template>
    <CompassModal
        :visible="visible"
        :title="$t.__('DeleteOcrProductLineModal.title')"
        :size="CompassEnums.Size.SMALL"
        :primaryAction="{
            label: $t.__('common.actions.delete'),
            type: 'primary-destructive',
            action: confirm,
        }"
        :secondaryActions="[
            {
                label: $t.__('common.actions.cancel'),
                type: 'secondary',
                action: cancel,
            },
        ]"
        @update:visible="updateVisible"
        @closed="onClosed"
    >
        <p class="typographies-paragraph-medium-semibold delete-modal__description">
            {{ $t.__('DeleteOcrProductLineModal.checkbox') }}
        </p>
        <CompassCheckbox
            modelValue="rememberChoice"
            :checked="rememberChoiceModel"
            :label="$t.__('ocr.DeleteOcrProductLineModal.do_not_ask_again')"
            @change="rememberChoiceModel = $event"
        />
    </CompassModal>
</template>

<script setup>
import { computed, ref, toRef, watch } from 'vue';

const props = defineProps({
    visible: {
        type: Boolean,
        required: true,
    },
    rememberChoice: {
        type: Boolean,
        required: true,
    },
});

const emit = defineEmits(['update:visible', 'confirm', 'cancel', 'update:rememberChoice']);

const rememberChoice = toRef(props, 'rememberChoice');

const storageKey = 'ocr.deleteProduct.skipConfirmation';
const storedRememberChoice = sessionStorage.getItem(storageKey);
const localRememberChoice = ref(
    storedRememberChoice === null ? rememberChoice.value : storedRememberChoice === 'true',
);

watch(rememberChoice, (newVal) => {
    localRememberChoice.value = newVal;
});

const rememberChoiceModel = computed({
    get: () => localRememberChoice.value,
    set: (value) => {
        localRememberChoice.value = value;
        sessionStorage.setItem(storageKey, value ? 'true' : 'false');
        emit('update:rememberChoice', value);
    },
});

emit('update:rememberChoice', localRememberChoice.value);

const confirm = () => emit('confirm');
const cancel = () => emit('cancel');
const updateVisible = (value) => emit('update:visible', value);

const onClosed = () => {
    cancel();
};
</script>

<style scoped lang="scss">
.delete-modal__description {
    margin: 0 0 var(--spacing-2) 0;
}
</style>
